import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

interface HeaderDropdownsProps extends HTMLAttributes<HTMLDivElement> {}

const UnstyledHeaderDropdowns: FunctionComponent<HeaderDropdownsProps> = (props) => {
  const { children, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={classNames({
        'header-dropdowns': true,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      {children}
    </div>
  );
};

const StyledHeaderDropdowns = styled(UnstyledHeaderDropdowns)`
  display: grid;
  grid-template-columns: min-content minmax(150px, max-content);
  margin-left: auto;
`;

export const HeaderDropdowns: FunctionComponent<HeaderDropdownsProps> = (props) => {
  return <StyledHeaderDropdowns {...props} />;
};
